import { useState, useEffect } from "react";
import { MailOutlined } from "@ant-design/icons";
import { Input, Modal } from "../../../../shared";
import { AppStrings } from "../../../../../utils/constants/AppStrings";
import styles from "./ChangeEmailModal.module.css";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function ChangeEmailModal({
  isOpen,
  onConfirm,
  onCancel,
  currentEmail,
  isLoading = false,
}) {
  const [newEmail, setNewEmail] = useState("");

  // Reset only when the parent closes the modal: on failure it stays open so
  // the operator can correct the address without re-typing it.
  useEffect(() => {
    if (!isOpen) setNewEmail("");
  }, [isOpen]);

  const normalizedEmail = newEmail.trim().toLowerCase();
  const isValidEmail = EMAIL_REGEX.test(normalizedEmail);
  const isConfirmDisabled = !isValidEmail || isLoading;

  const handleConfirm = () => {
    if (isConfirmDisabled) return;
    onConfirm(normalizedEmail);
  };

  return (
    <Modal
      open={isOpen}
      onClose={onCancel}
      size="md"
      width={450}
      destroyOnHidden
      data-testid="change-email-modal"
      title={
        <span className={styles.titleWithIcon}>
          <MailOutlined className={styles.icon} />
          {AppStrings.CHANGING_STAFF_EMAIL}
        </span>
      }
      secondaryAction={{
        label: AppStrings.NO,
        onClick: onCancel,
      }}
      primaryAction={{
        label: isLoading ? AppStrings.SAVING : AppStrings.YES_CHANGE_EMAIL,
        onClick: handleConfirm,
        loading: isLoading,
        disabled: isConfirmDisabled,
      }}
      maskClosable={!isLoading}
    >
      <p className={styles.warning}>{AppStrings.CHANGE_EMAIL_WARNING}</p>
      <div className={styles.form}>
        <div className={styles.field}>
          <span className={styles.fieldLabel}>{AppStrings.CURRENT_EMAIL}</span>
          <span className={styles.currentEmail}>{currentEmail ?? "-"}</span>
        </div>
        <div className={styles.field}>
          <label className={styles.fieldLabel} htmlFor="new-email-input">
            {AppStrings.NEW_EMAIL}
          </label>
          <Input
            id="new-email-input"
            type="email"
            placeholder={AppStrings.ENTER_NEW_EMAIL}
            value={newEmail}
            onChange={(e) => setNewEmail(e.target.value)}
          />
          {newEmail.trim() && !isValidEmail && (
            <span className={styles.validation}>
              {AppStrings.VALIDATION_INVALID_EMAIL}
            </span>
          )}
        </div>
      </div>
    </Modal>
  );
}

export default ChangeEmailModal;
